import { CardSuggestionTranslation } from "@models/card-suggestion-translation.model";
import { BaseConverter } from "./BaseConverter";
import { CardSuggestionTranslationDto } from "@dtos/card-suggestion-translation.dto";
import { CardSuggestionConverter } from "./cardSuggestionConverter";

export class CardSuggestionTranslationConverter extends BaseConverter<CardSuggestionTranslation, CardSuggestionTranslationDto>{
    private cardSuggestionConverter = new CardSuggestionConverter()
    modelToDto(model: CardSuggestionTranslation): CardSuggestionTranslationDto {
        return new CardSuggestionTranslationDto(
            model.id,
            model.title,
            model.location,
            model.details,
            model.link,
            model.locale,
            model.cardSuggestions ? this.cardSuggestionConverter.modelToDto(model.cardSuggestions) : undefined
        )
    }
    dtoToModel(dto: CardSuggestionTranslationDto): CardSuggestionTranslation {
        return new CardSuggestionTranslation(
            dto.id,
            dto.title,
            dto.location,
            dto.details,
            dto.link,
            dto.locale,
            dto.cardSuggestions ? this.cardSuggestionConverter.dtoToModel(dto.cardSuggestions) : undefined
        )
    }
}